const formatErrorMessage = (error) => {
  let errorMessage =
    'Please try again. If this issue continues, please contact us.';
  if (error?.message) {
    try {
      const parsedError = JSON.parse(error.message);
      errorMessage = Object.values(parsedError).join('. ');
    } catch (jsonError) {
      errorMessage = error.message;
    }
  }
  return errorMessage;
};

export default formatErrorMessage;
